<template>
  <div class="fillSpace" v-if="isProductEssilorLoaded && isProductLoaded">
    <div class="products" v-if="allLoaded()">
      <div class="element" style="height: 100%" v-show="!selecting || hasSelected">
        <!-- title, image, button -->
        <div class="beforeSelect">
          <img class="img-settings" :src="imagePath" />
          <p>{{ title }}</p>
        </div>
        <div class="checkbox-container">
          <div class="product" v-for="key in Object.keys(productsModified)" v-bind:key="key">
            <input
              :id="key"
              v-on:click="check(key)"
              type="checkbox"
              :checked="productsModified[key].isSelected"
              v-bind:class="{ required: productsModified[key].isRequired }"
            />
            <label :for="key" class="checkbox-label" v-bind:class="{ required: productsModified[key].isRequired }">{{
              productsModified[key].name
            }}</label>
            <br />
          </div>
        </div>
        <div class="bottom-settings">
          <span class="advert" v-show="numberSelected < 1">
            <img src="../../assets/ic-warning.png" />
            Conserver au moins 1 produit pour {{ title }}
          </span>
          <div class="productSelection">
            <span class="result">{{ numberSelected }}/{{ totalNumber }} produits</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['title', 'subtitle', 'category', 'image'],
  computed: {
    imagePath() {
      return require(`../../assets/${this.image}`);
    },
    products() {
      return this.$store.getters.productsByCategory(this.category);
    },
    productEssilor() {
      return this.$store.getters.productsEssilorByCategory(this.category);
    },
    isProductEssilorLoaded() {
      return this.$store.getters.isProductEssilorLoaded();
    },
    isProductLoaded() {
      return this.$store.getters.isProductsLoaded();
    },
  },
  data() {
    return {
      productsModified: {},
      beforeSelect: true,
      selecting: false,
      hasSelected: false,
      selected: {
        name: this.subtitle,
        id: false,
      },
      demos: [],
      numberSelected: 0,
      totalNumber: 0,
      selectedProducts: [],
      initDone: false,
    };
  },
  created() {
    /*      this.$store.getters
              .productsByCategory(this.category)
              .filter(product => product.isActive === true)
              .forEach(activeProduct => {
                this.selectedProducts.push(activeProduct.id);
              });*/
  },
  methods: {
    allLoaded() {
      if (!this.initDone) {
        this.initDone = true;
        this.productEssilor.forEach(product => {
          if (product.demos.length > 0) {
            this.productsModified[product.id] = product;
            this.productsModified[product.id].isSelected = false;
            this.productsModified[product.id].isRequired = product.isRequired;
            this.products.forEach(productCompare => {
              if (productCompare.name === product.name) {
                this.productsModified[product.id].isSelected = true;
              }
            });
          }
        });
      }
      this.$emit('loaded', { [this.category]: this.productsModified });
      this.numberSelected = Object.values(this.productsModified).filter(product => product.isSelected).length;
      this.totalNumber = Object.values(this.productsModified).length;
      return true;
    },
    updateSelected() {
      this.$log.debug('countactive', Object.values(this.productsModified));
      this.numberSelected = Object.values(this.productsModified).filter(product => product.isSelected).length;
      this.totalNumber = Object.values(this.productsModified).length;
      this.$emit('loaded', { [this.category]: this.productsModified });
    },
    check(id) {
      this.productsModified[id].isSelected = !this.productsModified[id].isSelected;
      this.updateSelected();
      this.$log.debug(this.productsModified);
    },
  },
};
</script>

<style scoped>
.required {
  color: grey;
  pointer-events: none;
}

.element {
  display: flex;
  flex-direction: column;
}
.advert {
  font-size: 0.9em;
  color: #ff8e33;
  padding: 0 6%;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
}

.advert img {
  width: 1vw;
  margin-right: 0.5vw;
}

.productSelection {
  display: flex;
  align-items: center;
  font-size: 1.2em;
  border-top: 1px solid lightgray;
  height: 4em;
  margin: 5% 20% 0 20%;
  opacity: 0.5;
}

.checkbox-container {
  display: flex;
  justify-content: left;
  flex-direction: column;
  width: 70%;
  height: 100%;
  margin-left: 10.5%;
}

.fillSpace {
  padding-top: 30px;
  position: relative;
  height: 100%;
  width: 90%;
  align-items: center;
  justify-content: center;
}

.beforeSelect {
  width: 100%;
}

.beforeSelect p {
  margin: 0 0 40px;
}

.products {
  width: 100%;
  height: 100%;
}

.product {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  font-size: 17px;
}

.bottom-settings {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  margin-bottom: 1vh;
}

input[type='checkbox'] {
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  border-radius: 4px;
  height: 17px;
  width: 17px;
  background: #fff;
  border: 1px solid #ccc;
}

input[type='checkbox']:checked {
  position: relative;
}

input[type='checkbox']:checked ~ .checkbox-label {
  border-bottom: 1px solid #0d52a0;
  padding-bottom: 2px;
}

.checkbox-label {
  cursor: pointer;
  font-size: 1em;
  margin-left: 12px;
  white-space: nowrap;
}

.product:hover .checkbox-label {
  border-bottom: 1px solid #0d52a0;
  padding-bottom: 2px;
}

input[type='checkbox']:checked:before {
  background: black;
  content: '';
  position: absolute;
  left: 2px;
  top: 7px;
  width: 2px;
  height: 2px;
  box-shadow: 2px 0 0 black, 4px 0 0 black, 4px -2px 0 black, 4px -4px 0 black, 4px -6px 0 black, 4px -8px 0 black;
  transform: rotate(45deg);
}

.result {
  margin: auto;
}
.img-settings {
  width: 48px;
}

@media screen and (max-width: 1440px) {
  .fillSpace {
    padding-top: 30px;
  }

  .beforeSelect p {
    margin: 0 0 16px;
  }
}
/*
résolution moins de 1280
*/
@media (max-width: 1280px) {
  .img-settings {
    width: 35px;
  }
  .beforeSelect p {
    font-size: 16px;
    margin: 0 0 18px;
  }
  .checkbox-label {
    font-size: 12px;
    margin-left: 4px;
  }
  .product {
    margin-bottom: 5px;
  }
  .checkbox-container {
    margin-left: 20px;
  }
  .advert {
    font-size: 12px;
  }
  .productSelection {
    font-size: 12px;
  }
}
</style>
